class EventsSender {
	public sendWishlistEvents(): void {
		document.dispatchEvent(new Event('wishlist_button_initialize'));
	}
}

export default new EventsSender();
